<template>
    <div id="overlay">
        <div class="dialog-wrap">
            <div class='table-dialog-top'>
                <div class='dialog_title'>表の説明</div>
                <div class='table-back-ground'>
                    <table class="startdialogSelectTableBody">
                        <thead style="background: white;">
                            <tr align="center">
                                <th class="tableheader sp_not">スタート時間</th>
                                <th class="tableheader sp_not">コース</th>
                                <th class="tableheader">人数</th>
                                <th class="tableheader table_tops">予約可能数</th>
                            </tr>
                        </thead>
                        <tbody style="background: white;">
                            <tr v-for="info in course_time_info" :key="info.id" align="center">
                                <td class="sp_not">{{ info.start_time }}</td>
                                <td class="sp_not">{{ info.course_status }}</td>
                                <td>
                                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                        <template v-for="(val, index) in info.count">
                                            <input
                                                :class="{ 'radio-inline__input': true }"
                                                type="radio"
                                                :name="`accessible-radio-${info.id}`"
                                                :key="`${info.id}-${index + 1}-1`"
                                                :disabled="index + 1 <= info.least_num"
                                            />
                                            <label
                                                class="radio-inline__label"
                                                :for="`${info.id}-${index + 1}`"
                                                :key="`${info.id}-${index + 1}-2`"
                                                :class="{
                                                      disabledCell: index + 1 <= info.least_num
                                                }"
                                            >
                                                <span v-if="val.name === ''">
                                                    {{ index + 1 }}
                                                </span>
                                                <span v-else-if="val.name !== ''">
                                                    <svg class="bi bi-person-fill" width="1.5em" height="1.5em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                                                    </svg>
                                                </span>
                                            </label>
                                        </template>
                                    </div>
                                </td>
                                <td class="table_tops">
                                    {{ info.remarks }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="startdialogSelectTableBody" style="margin-top: 30px;">
                        <thead style="background: white;">
                            <tr align="center">
                                <th class="tableheader sp_not">スタート時間</th>
                                <th class="tableheader sp_not">コース</th>
                                <th class="tableheader">人数</th>
                                <th class="tableheader table_tops"></th>
                            </tr>
                        </thead>
                        <tbody style="background: white;">
                            <tr v-for="info in course_time_infos" :key="info.id" align="center">
                                <td class="sp_not">{{ info.start_time }}</td>
                                <td class="sp_not">{{ info.course_status }}</td>
                                <td v-if="info.count.length === 0" class="disabledCell">-</td>
                                <td v-else>
                                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                        <template v-for="(val, index) in info.count">
                                            <input
                                                :class="{ 'radio-inline__input': true }"
                                                type="radio"
                                                :name="`accessible-radio2-${info.id}`"
                                                :key="`${info.id}-${index + 1}-1`"
                                                :disabled="index + 1 <= info.least_num"
                                            />
                                            <label
                                                class="radio-inline__label"
                                                :for="`${info.id}-${index + 1}`"
                                                :key="`${info.id}-${index + 1}-2`"
                                                :class="{
                                                    disabledCell: index + 1 <= info.least_num
                                                }"
                                            >
                                                <span v-if="val.name === ''">
                                                  {{ index + 1 }}
                                                </span>
                                                <span v-else-if="val.name !== ''">
                                                    <svg class="bi bi-person-fill" width="1.5em" height="1.5em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                                                    </svg>
                                                </span>
                                            </label>
                                        </template>
                                    </div>
                                </td>
                                <td>
                                    {{ info.remarks }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="table-dialog__message">
                    <div>※組合せ枠</div>
                    <div>右側の数字が人マークの場合は既に予約者が入っているため、組合せになります。</div>
                </div>
                <div class="dialog-wrap__btnArea">
                    <button class="bluebackbutton dialogBtn" v-on:click="clickEvent">閉じる</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    data () {
        return {
            // コース時間配列（中身は空）tableSwitchingメソッドにてダミーのデータを入れている
            course_time_info: [
              { id:'1', start_time: '7:49', course_status: 'OUT', least_num: '1', remarks: '2名以上から予約可能',
                count: [
                  { id: '1', name: '', click_flag: '0' },
                  { id: '2', name: '', click_flag: '0' },
                  { id: '3', name: '', click_flag: '0' },
                  { id: '4', name: '', click_flag: '0' }
              ]},
              { id:'2', start_time: '7:56', course_status: 'OUT', least_num: '2', remarks: '3名以上から予約可能',
                count: [
                  { id: '1', name: '', click_flag: '0' },
                  { id: '2', name: '', click_flag: '0' },
                  { id: '3', name: '', click_flag: '0' },
                  { id: '4', name: '', click_flag: '0' }
              ]},
              { id:'3', start_time: '8:03', course_status: 'OUT', least_num: '3', remarks: '4名以上から予約可能',
                count: [
                  { id: '1', name: '', click_flag: '0' },
                  { id: '2', name: '', click_flag: '0' },
                  { id: '3', name: '', click_flag: '0' },
                  { id: '4', name: '', click_flag: '0' }
              ]}
            ],
            course_time_infos: [
              { id:'1', start_time: '7:49', course_status: 'OUT', least_num: '', remarks: '4名まで予約可能',
                count: [
                  { id: '1', name: '', click_flag: '0' },
                  { id: '2', name: '', click_flag: '0' },
                  { id: '3', name: '', click_flag: '0' },
                  { id: '4', name: '', click_flag: '0' }
              ]},
              { id:'2', start_time: '7:56', course_status: 'OUT', least_num: '', remarks: '3名まで予約可能',
                count: [
                  { id: '1', name: '', click_flag: '0' },
                  { id: '2', name: '', click_flag: '0' },
                  { id: '3', name: '', click_flag: '0' },
                  { id: '4', name: '1', click_flag: '0' }
              ]},
              { id:'3', start_time: '8:03', course_status: 'OUT', least_num: '', remarks: '2名まで予約可能',
                count: [
                  { id: '1', name: '', click_flag: '0' },
                  { id: '2', name: '', click_flag: '0' },
                  { id: '3', name: '1', click_flag: '0' },
                  { id: '4', name: '1', click_flag: '0' }
              ]},
              { id:'4', start_time: '8:10', course_status: 'OUT', least_num: '', remarks: '1名のみ予約可能',
                count: [
                  { id: '1', name: '', click_flag: '0' },
                  { id: '2', name: '1', click_flag: '0' },
                  { id: '3', name: '1', click_flag: '0' },
                  { id: '4', name: '1', click_flag: '0' }
              ]}
            ],
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        async initialize () {
        },
        clickEvent (){
            this.$emit('from-TableDialog');
        }
    }
}
</script>

<style scoped>
table {
  width: 100%;
}
th{
  border: solid 1px #e8e8e8;
}
td{
  border: solid 1px #e8e8e8;
}
@media screen and (max-width: 896px) {
    .table-explanation-bodytd{
        padding: 10px;
    }
    .radio-inline__label{
        width: 30px;
    }
}
@media screen and (max-width: 575px) {
    .radio-inline__label {
        margin: 0 2px 0 0;
    }
}
</style>
